var _defs, _path, _path2, _path3, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167, _text168, _text169, _text170, _text171, _text172, _text173, _text174, _text175, _text176, _text177, _text178, _text179, _text180, _text181, _text182, _text183, _text184, _text185, _text186, _text187, _text188, _text189, _text190, _text191, _text192, _text193, _path4, _path5, _path6, _path7, _path8, _path9, _text194, _text195, _text196, _text197, _text198, _text199, _text200, _text201, _text202, _text203, _text204, _text205, _text206, _text207, _text208, _text209, _text210, _text211, _text212, _text213, _text214, _text215, _text216, _text217, _text218, _text219, _text220, _text221, _text222, _text223, _text224, _text225;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5RearFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "de76eae8-4193-4f8a-a6a9-b1695833c52f",
    "data-name": "Compass Frame",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:12.98px;font-family:MyriadPro-Regular, Myriad Pro;}.crp5_108{fill:none}.crp5_109,.crp5_108{stroke:#000;stroke-miterlimit:10;stroke-width:0.5px}.crp5_109{fill:#fff}.crp5_111{font-size:7.53px}.crp5_111,.crp5_115,.crp5_114{font-family:HelveticaNeue-Roman, Helvetica Neue}.crp5_114{font-size:8.6px}.crp5_115{font-size:11px}.crp5_116{fill:url(#7eb0b798-28a3-4489-9dec-acbf166c65b3)}.crp5_117{fill:url(#6c2ae54b-efc4-44c6-8373-c46e9308d745)}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "35cc75b0-dcd5-4ead-ac91-d9cfe097cfe6",
    cx: -22.62,
    cy: 839.17,
    r: 1.29,
    gradientTransform: "matrix(8.29, 0, 0, -8.29, 308.16, 7267.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "7eb0b798-28a3-4489-9dec-acbf166c65b3",
    cx: 20.92,
    cy: 839.15,
    r: 1.29,
    xlinkHref: "#35cc75b0-dcd5-4ead-ac91-d9cfe097cfe6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "6c2ae54b-efc4-44c6-8373-c46e9308d745",
    cx: -22.57,
    cy: 813.68,
    r: 1.29,
    xlinkHref: "#35cc75b0-dcd5-4ead-ac91-d9cfe097cfe6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "672eb7f4-1e2e-40bf-bc57-cfc041ad3e4a",
    cx: 20.96,
    cy: 813.67,
    r: 1.29,
    xlinkHref: "#35cc75b0-dcd5-4ead-ac91-d9cfe097cfe6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crp5_108",
    d: "M297.26 195.42a225 225 0 0 0-201 123.78l-.11.22h.11v81.5h10.54c9.77-96.6 91.33-172 190.51-172s180.75 75.39 190.52 172h10.65v-81.25a225 225 0 0 0-201.22-124.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_109",
    d: "M498.71 521.93v-82.5h-10.54c-9.77 96.61-91.33 173-190.51 173s-180.74-76.43-190.52-173H96.49v82.26a225.08 225.08 0 0 0 402.22.47l.11-.23zm-381.5 12a7.75 7.75 0 1 1 7.75-7.75 7.74 7.74 0 0 1-7.75 7.74zm360.74 0a7.75 7.75 0 1 1 7.75-7.75 7.74 7.74 0 0 1-7.7 7.74zM297.26 195.42a225 225 0 0 0-201 123.78l-.11.22h.11v81.5h10.54c9.77-96.6 91.33-172 190.51-172s180.75 75.39 190.52 172h10.65v-81.25a225 225 0 0 0-201.22-124.25zM116.87 322.73a7.75 7.75 0 1 1 7.75-7.75 7.75 7.75 0 0 1-7.75 7.75zm360.64 0a7.75 7.75 0 1 1 7.75-7.75 7.75 7.75 0 0 1-7.75 7.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_108",
    d: "M297.31 227.59v-8.67M149.72 296.14l-6.62-5.6M444.6 295.77l6.6-5.61M280.28 228.34l-.76-8.63M263.74 230.53l-1.51-8.53M247.36 234.16l-2.24-8.37M231.28 239.23l-2.97-8.14M215.74 245.66l-3.66-7.86M201.06 253.28l-4.32-7.51M187.17 262.07l-4.94-7.12M173.56 272.44l-5.55-6.66M161.06 283.83l-6.11-6.14M433.13 283.4l6.09-6.16M420.77 272.19l5.54-6.66M407.42 262.04l4.93-7.12M393.15 253.04l4.3-7.52M378.2 245.34l3.63-7.87M362.9 239.07l2.94-8.16M347.22 234.15l2.24-8.37M330.51 230.47l1.49-8.54M313.74 228.29l.74-8.63M293.78 227.62l-.1-5.45M290.42 227.71l-.19-5.45M286.91 227.87l-.29-5.45M283.65 228.08l-.39-5.45M276.93 228.67l-.58-5.43M273.65 229.05l-.67-5.42M270.28 229.49l-.77-5.4M267.03 229.98l-.86-5.39M260.24 231.18l-1.05-5.35M257.12 231.82l-1.14-5.34M250.46 233.36l-1.33-5.29M253.6 232.6l-1.23-5.31M244.11 235.06l-1.5-5.25M240.96 235.99l-1.59-5.22M237.79 236.99l-1.68-5.19M234.51 238.09l-1.78-5.16M228.18 240.38l-1.95-5.09M225.19 241.56l-2.04-5.06M221.93 242.91l-2.13-5.03M219.08 244.14l-2.21-4.99M212.77 247.07l-2.39-4.9M209.82 248.54l-2.48-4.86M207.08 249.96l-2.55-4.82M203.96 251.65l-2.64-4.78M198.17 254.98l-2.8-4.69M192.7 258.37l-2.96-4.59M189.87 260.23l-3.04-4.54M195.35 256.69l-2.88-4.63M181.62 266.07l-3.27-4.37M184.27 264.12l-3.2-4.42M178.92 268.13l-3.35-4.31M176.35 270.16l-3.42-4.26M171.14 274.49l-3.57-4.13M168.48 276.83l-3.64-4.07M166.06 279.03l-3.7-4M163.63 281.32l-3.77-3.94M158.92 286l-3.91-3.81M156.55 288.47l-3.97-3.74M154.21 291.01l-4.04-3.67M152.18 293.29l-4.1-3.6M300.23 227.62l.1-5.45M303.58 227.71l.2-5.45M307.09 227.87l.3-5.45M310.36 228.08l.38-5.45M317.08 228.67l.57-5.43M320.36 229.05l.67-5.42M323.73 229.49l.76-5.4M326.98 229.98l.86-5.39M333.77 231.18l1.05-5.35M336.89 231.82l1.13-5.34M343.55 233.36l1.32-5.29M340.4 232.6l1.24-5.31M349.89 235.06l1.51-5.25M353.04 235.99l1.59-5.22M356.21 236.99l1.68-5.19M359.5 238.09l1.77-5.16M365.82 240.38l1.95-5.09M368.82 241.56l2.03-5.06M372.08 242.91l2.13-5.03M374.92 244.14l2.21-4.99M381.23 247.07l2.39-4.9M384.19 248.54l2.47-4.86M386.93 249.96l2.55-4.82M390.04 251.65l2.64-4.78M395.84 254.98l2.8-4.69M401.31 258.37l2.95-4.59M404.14 260.23l3.03-4.54M398.66 256.69l2.88-4.63M412.38 266.07l3.27-4.37M409.74 264.12l3.19-4.42M415.09 268.13l3.34-4.31M417.66 270.16l3.42-4.26M422.87 274.49l3.56-4.13M425.53 276.83l3.64-4.07M427.94 279.03l3.71-4M430.37 281.32l3.78-3.94M435.09 286l3.91-3.81M437.45 288.47l3.98-3.74M439.8 291.01l4.04-3.67M441.83 293.29l4.1-3.6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.63, -0.76, 0.77, 0.64, 139.59, 291.88)"
  }, "5")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.65, -0.75, 0.76, 0.65, 142.3, 288.62)"
  }, "0")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.66, -0.74, 0.75, 0.67, 145.08, 285.42)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.67, -0.73, 0.74, 0.68, 146.54, 283.8)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(148.01 282.19) rotate(-46.92) scale(0.99 1)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(149.48 280.62) rotate(-46.3) scale(0.99 1)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.69, -0.71, 0.72, 0.7, 151, 279.03)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(152.51 277.48) rotate(-45.05) scale(0.99 1)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(154.04 275.95) rotate(-44.43) scale(0.99 1)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.72, -0.69, 0.69, 0.72, 155.59, 274.43)"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(157.17 272.92) rotate(-43.18) scale(0.99 1)"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(158.75 271.44) rotate(-42.56) scale(0.99 1)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.74, -0.66, 0.67, 0.74, 160.34, 269.98)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.74, -0.65, 0.66, 0.75, 161.98, 268.51)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(163.59 267.08) rotate(-40.4) scale(0.99 1)"
  }, "4")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.77, -0.63, 0.63, 0.77, 166.82, 264.33)"
  }, "0")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.78, -0.61, 0.62, 0.78, 170.11, 261.66)"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.78, -0.61, 0.61, 0.79, 171.82, 260.31)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.79, -0.6, 0.6, 0.8, 173.54, 258.98)"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.8, -0.59, 0.59, 0.8, 175.27, 257.67)"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.8, -0.58, 0.59, 0.81, 177.02, 256.38)"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(178.79 255.11) rotate(-35.19) scale(0.99 1)"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(180.55 253.87) rotate(-34.58) scale(0.99 1)"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(182.34 252.63) rotate(-33.96) scale(0.99 1)"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.83, -0.54, 0.55, 0.84, 184.13, 251.43)"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.83, -0.54, 0.54, 0.84, 185.95, 250.23)"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.84, -0.53, 0.53, 0.85, 187.79, 249.05)"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(189.64 247.89) rotate(-31.5) scale(0.99 1)"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(191.48 246.76) rotate(-30.59) scale(0.99 1)"
  }, "3")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(195.11 244.61) rotate(-29.39) scale(0.99 1)"
  }, "0")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(198.82 242.53) rotate(-28.48) scale(0.99 1)"
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.88, -0.46, 0.47, 0.88, 200.71, 241.5)"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(202.65 240.48) rotate(-27.25) scale(0.99 1)"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(204.57 239.49) rotate(-26.64) scale(0.99 1)"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(206.52 238.52) rotate(-26.02) scale(0.99 1)"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(208.48 237.56) rotate(-25.41) scale(0.99 1)"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.9, -0.42, 0.42, 0.91, 210.43, 236.63)"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.9, -0.41, 0.41, 0.91, 212.4, 235.72)"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(214.38 234.83) rotate(-23.57) scale(0.99 1)"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.91, -0.39, 0.39, 0.92, 216.37, 233.97)"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(218.37 233.12) rotate(-22.34) scale(0.99 1)"
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(220.38 232.29) rotate(-21.72) scale(0.99 1)"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(222.41 231.49) rotate(-21.11) scale(0.99 1)"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(224.44 230.7) rotate(-20.2) scale(0.99 1)"
  }, "2")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(228.4 229.24) rotate(-19.01) scale(0.99 1)"
  }, "0")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(232.41 227.87) rotate(-18.1) scale(0.99 1)"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.94, -0.3, 0.3, 0.95, 234.48, 227.19)"
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.95, -0.29, 0.29, 0.96, 236.54, 226.54)"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(238.64 225.9) rotate(-16.26) scale(0.99 1)"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.95, -0.27, 0.27, 0.96, 240.72, 225.3)"
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(242.81 224.72) rotate(-15.04) scale(0.99 1)"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(244.91 224.15) rotate(-14.43) scale(0.99 1)"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(247.01 223.61) rotate(-13.81) scale(0.99 1)"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.96, -0.23, 0.23, 0.97, 249.13, 223.09)"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(251.25 222.59) rotate(-12.59) scale(0.99 1)"
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(253.35 222.13) rotate(-11.99) scale(0.99 1)"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.97, -0.2, 0.2, 0.98, 255.49, 221.67)"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(257.62 221.24) rotate(-10.47) scale(0.99 1)"
  }, "1")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.98, -0.16, 0.16, 0.99, 261.77, 220.47)"
  }, "0")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(265.96 219.79) rotate(-8.4) scale(0.99 1)"
  })), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.99, 0.02, -0.02, 1, 296.4, 217.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.2,
    y: -0.02
  }))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(300.74 217.45) rotate(1.22) scale(0.99 1)"
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(302.92 217.5) rotate(1.82) scale(0.99 1)"
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(305.1 217.57) rotate(2.41) scale(0.99 1)"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.99, 0.05, -0.05, 1, 307.27, 217.66)"
  })), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(309.44 217.77) rotate(3.61) scale(0.99 1)"
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.99, 0.07, -0.07, 1, 311.6, 217.91)"
  })), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(313.79 218.07) rotate(4.81) scale(0.99 1)"
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(315.94 218.25) rotate(5.41) scale(0.99 1)"
  })), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(318.12 218.46) rotate(6.01) scale(0.99 1)"
  })), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.98, 0.11, -0.12, 0.99, 320.25, 218.68)"
  })), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(322.42 218.94) rotate(7.22) scale(0.99 1)"
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(324.58 219.21) rotate(7.82) scale(0.99 1)"
  })), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(326.73 219.51) rotate(8.43) scale(0.99 1)"
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(328.86 219.82) rotate(9.32) scale(0.99 1)"
  }, "1")), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(333.05 220.5) rotate(10.51) scale(0.99 1)"
  }, "0")), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.97, 0.2, -0.2, 0.98, 337.22, 221.29)"
  })), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(339.37 221.72) rotate(12.02) scale(0.99 1)"
  })), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(341.47 222.17) rotate(12.62) scale(0.99 1)"
  })), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.96, 0.23, -0.23, 0.97, 343.59, 222.64)"
  })), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.96, 0.24, -0.24, 0.97, 345.71, 223.14)"
  })), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.96, 0.25, -0.25, 0.97, 347.83, 223.66)"
  })), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.96, 0.26, -0.26, 0.97, 349.93, 224.21)"
  })), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.95, 0.27, -0.27, 0.96, 352.02, 224.77)"
  })), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(354.1 225.36) rotate(16.29) scale(0.99 1)"
  })), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(356.22 225.97) rotate(16.91) scale(0.99 1)"
  })), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(358.28 226.6) rotate(17.52) scale(0.99 1)"
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(360.35 227.26) rotate(18.13) scale(0.99 1)"
  })), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(362.42 227.93) rotate(19.04) scale(0.99 1)"
  }, "2")), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(366.41 229.3) rotate(20.23) scale(0.99 1)"
  }, "0")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(370.39 230.78) rotate(21.14) scale(0.99 1)"
  })), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(372.43 231.57) rotate(21.76) scale(0.99 1)"
  })), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(374.45 232.37) rotate(22.37) scale(0.99 1)"
  })), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(376.45 233.2) rotate(22.99) scale(0.99 1)"
  })), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(378.45 234.05) rotate(23.6) scale(0.99 1)"
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(380.44 234.92) rotate(24.21) scale(0.99 1)"
  })), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(382.42 235.81) rotate(24.83) scale(0.99 1)"
  })), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.89, 0.43, -0.43, 0.9, 384.38, 236.72)"
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(386.37 237.66) rotate(26.06) scale(0.99 1)"
  })), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.89, 0.44, -0.45, 0.89, 388.31, 238.61)"
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(390.23 239.58) rotate(27.28) scale(0.99 1)"
  })), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(392.18 240.59) rotate(27.9) scale(0.99 1)"
  })), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(394.09 241.6) rotate(28.52) scale(0.99 1)"
  })), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(396 242.63) rotate(29.42) scale(0.99 1)"
  }, "3")), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(399.68 244.7) rotate(30.62) scale(0.99 1)"
  }, "0")), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(403.34 246.88) rotate(31.53) scale(0.99 1)"
  })), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.84, 0.53, -0.53, 0.85, 405.18, 248.01)"
  })), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(407.03 249.17) rotate(32.77) scale(0.99 1)"
  })), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(408.86 250.35) rotate(33.38) scale(0.99 1)"
  })), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.82, 0.55, -0.56, 0.83, 410.68, 251.55)"
  })), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.82, 0.56, -0.57, 0.82, 412.46, 252.76)"
  })), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.81, 0.57, -0.58, 0.82, 414.25, 253.99)"
  })), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.8, 0.58, -0.59, 0.81, 416.03, 255.25)"
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(417.79 256.52) rotate(36.47) scale(0.99 1)"
  })), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(419.54 257.81) rotate(37.08) scale(0.99 1)"
  })), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(421.28 259.13) rotate(37.71) scale(0.99 1)"
  })), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.78, 0.61, -0.62, 0.78, 423, 260.46)"
  })), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.77, 0.63, -0.63, 0.77, 424.68, 261.78)"
  }, "4")), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.75, 0.64, -0.65, 0.76, 427.98, 264.47)"
  }, "0")), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.74, 0.65, -0.66, 0.75, 431.21, 267.24)"
  })), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.74, 0.66, -0.67, 0.74, 432.83, 268.67)"
  })), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(434.44 270.11) rotate(42.59) scale(0.99 1)"
  })), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.72, 0.68, -0.68, 0.73, 436.03, 271.58)"
  })), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.71, 0.69, -0.69, 0.72, 437.63, 273.08)"
  })), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(439.19 274.58) rotate(44.46) scale(0.99 1)"
  })), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.7, 0.7, -0.71, 0.71, 440.73, 276.09)"
  })), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.69, 0.71, -0.72, 0.7, 442.27, 277.64)"
  })), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(443.79 279.2) rotate(46.33) scale(0.99 1)"
  })), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(445.28 280.76) rotate(46.95) scale(0.99 1)"
  })), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.67, 0.73, -0.74, 0.67, 446.78, 282.36)"
  })), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.66, 0.74, -0.75, 0.67, 448.24, 283.96)"
  })), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "translate(449.68 285.57) rotate(49.12) scale(0.99 1)"
  }, "5")), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_111",
    transform: "matrix(0.63, 0.76, -0.77, 0.64, 452.46, 288.77)"
  }, "0")), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.64, -0.81, 0.79, 0.62, 127.43, 290.53)"
  }, "D")), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(131.34 285.57) rotate(-50) scale(1.03 1)"
  }, "R")), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(135.31 280.88) rotate(-48.77) scale(1.03 1)"
  }, "I")), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(136.87 279.07) rotate(-47.7) scale(1.03 1)"
  }, "F")), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.71, -0.74, 0.72, 0.69, 140.35, 275.25)"
  }, "T")), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.72, -0.73, 0.71, 0.71, 143.95, 271.52)"
  })), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.74, -0.71, 0.69, 0.72, 145.73, 269.71)"
  }, "P")), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(149.91 265.67) rotate(-42.19) scale(1.03 1)"
  }, "O")), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(154.96 261.1) rotate(-40.38) scale(1.03 1)"
  }, "R")), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.8, -0.64, 0.63, 0.78, 159.54, 257.21)"
  }, "T")), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(163.57 253.98) rotate(-37.78) scale(1.03 1)"
  })), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(182.22 240.93) rotate(-31.54) scale(1.03 1)"
  })), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(184.4 239.57) rotate(-30.44) scale(1.03 1)"
  }, "V")), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.9, -0.5, 0.49, 0.87, 188.78, 236.99)"
  }, "A")), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.91, -0.47, 0.46, 0.89, 193.86, 234.17)"
  }, "R")), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(199.34 231.36) rotate(-26.23) scale(1.03 1)"
  }, ".")), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(201.65 230.22) rotate(-25.54) scale(1.03 1)"
  })), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(203.96 229.1) rotate(-24.45) scale(1.03 1)"
  }, "E")), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(208.95 226.83) rotate(-22.94) scale(1.03 1)"
  }, "A")), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.96, -0.37, 0.36, 0.93, 214.3, 224.57)"
  }, "S")), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(219.73 222.45) rotate(-19.92) scale(1.03 1)"
  }, "T")), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.97, -0.33, 0.32, 0.95, 224.59, 220.7)"
  })), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(250.84 213.37) rotate(-11.68) scale(1.03 1)"
  })), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(254.45 212.61) rotate(-10.19) scale(1.03 1)"
  }, "T")), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(260.95 211.44) rotate(-8.3) scale(1.03 1)"
  }, "R")), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(268.71 210.3) rotate(-6.21) scale(1.03 1)"
  }, "U")), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(1.02, -0.08, 0.07, 1, 276.95, 209.42)"
  }, "E")), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(1.03, -0.05, 0.05, 1, 283.99, 208.92)"
  })), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(287.24 208.73) rotate(-1.43) scale(1.03 1)"
  }, "H")), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(1.03, 0.02, -0.02, 1, 295.53, 208.51)"
  }, "E")), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(302.55 208.59) rotate(2.35) scale(1.03 1)"
  }, "A")), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(309.98 208.9) rotate(4.34) scale(1.03 1)"
  }, "D")), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(318.05 209.54) rotate(5.78) scale(1.03 1)"
  }, "I")), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(321.09 209.82) rotate(7.25) scale(1.03 1)"
  }, "N")), _text168 || (_text168 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(1.01, 0.17, -0.16, 0.99, 329.31, 210.86)"
  }, "G")), _text169 || (_text169 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(1.01, 0.2, -0.19, 0.98, 337.87, 212.33)"
  })), _text170 || (_text170 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "translate(361.08 218.01) rotate(17.33) scale(1.03 1)"
  })), _text171 || (_text171 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_115",
    transform: "matrix(0.98, 0.32, -0.31, 0.95, 364.23, 218.99)"
  })), _text172 || (_text172 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.97, 0.34, -0.33, 0.94, 367.33, 220)"
  }, "V")), _text173 || (_text173 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.96, 0.36, -0.35, 0.93, 372.14, 221.69)"
  }, "A")), _text174 || (_text174 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.95, 0.39, -0.38, 0.92, 377.58, 223.75)"
  }, "R")), _text175 || (_text175 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(383.26 226.11) rotate(23.54) scale(1.03 1)"
  }, ".")), _text176 || (_text176 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.94, 0.42, -0.41, 0.91, 385.63, 227.14)"
  })), _text177 || (_text177 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(387.96 228.15) rotate(25.68) scale(1.03 1)"
  }, "W")), _text178 || (_text178 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(395.4 231.76) rotate(27.54) scale(1.03 1)"
  }, "E")), _text179 || (_text179 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(400.28 234.3) rotate(29.07) scale(1.03 1)"
  }, "S")), _text180 || (_text180 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(405.36 237.13) rotate(30.56) scale(1.03 1)"
  }, "T")), _text181 || (_text181 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(409.81 239.77) rotate(31.61) scale(1.03 1)"
  })), _text182 || (_text182 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.82, 0.62, -0.61, 0.8, 427.03, 251.44)"
  })), _text183 || (_text183 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(429.07 252.97) rotate(38.53) scale(1.03 1)"
  }, "D")), _text184 || (_text184 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(434.02 256.91) rotate(40.26) scale(1.03 1)"
  }, "R")), _text185 || (_text185 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.77, 0.68, -0.66, 0.75, 438.7, 260.91)"
  }, "I")), _text186 || (_text186 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(440.49 262.47) rotate(42.51) scale(1.03 1)"
  }, "F")), _text187 || (_text187 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(444.3 265.96) rotate(43.96) scale(1.03 1)"
  }, "T")), _text188 || (_text188 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.73, 0.73, -0.71, 0.71, 448.01, 269.56)"
  })), _text189 || (_text189 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(449.84 271.37) rotate(46.23) scale(1.03 1)"
  }, "S")), _text190 || (_text190 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.69, 0.76, -0.74, 0.67, 453.86, 275.57)"
  }, "T")), _text191 || (_text191 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.67, 0.78, -0.76, 0.65, 457.34, 279.4)"
  }, "B")), _text192 || (_text192 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "matrix(0.64, 0.8, -0.78, 0.63, 461.34, 284.07)"
  }, "D")), _text193 || (_text193 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_114",
    transform: "translate(465.26 288.99) rotate(52.48) scale(1.03 1)"
  }, ".")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.76 211.04l-8.53 12.22-8.53-12.22h17.06z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.56 315h1.28a10 10 0 0 1-10 10v-1.29V325a10 10 0 0 1-10-10l1.28.05h-1.29a10 10 0 0 1 10-10v1.14l-.06-1.14h.06v1.14l-.06-1.14h.07a10 10 0 0 1 10 10h-1.22l1.22-.1v.1h-1.22l1.22-.1v.1h-1.28l-1.28.11V315a7.43 7.43 0 0 0-7.45-7.43v-1.29l.06 1.29h-.07a7.43 7.43 0 0 0-7.43 7.44v.06l-1.18-.05h1.18v.05l-1.18-.05h1.18a7.43 7.43 0 0 0 7.44 7.43v1.08-1.08 1.08-1.08a7.44 7.44 0 0 0 7.43-7.45h1.29l-1.28.11z",
    fill: "url(#35cc75b0-dcd5-4ead-ac91-d9cfe097cfe6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_116",
    d: "M486.28 315h1.29a10 10 0 0 1-10 10h-.06l.05-1.29V325a10 10 0 0 1-10-10l1.28.05h-1.28a10 10 0 0 1 10-10v1.14l-.05-1.14h.05v1.14l-.05-1.14h.06a10 10 0 0 1 10 10h-1.23l1.22-.1v.1h-1.23l1.22-.1v.1h-1.29l-1.28.11V315a7.44 7.44 0 0 0-7.45-7.43v-1.29l.06 1.29h-.07a7.43 7.43 0 0 0-7.43 7.44v.06l-1.18-.05h1.18v.05l-1.18-.05h1.18a7.45 7.45 0 0 0 7.45 7.43v1.08-1.08 1.08-1.08A7.45 7.45 0 0 0 485 315h1.28l-1.28.11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_117",
    d: "M126.06 526.16h1.28a10 10 0 0 1-10 10v-1.28 1.28a10 10 0 0 1-10-10v-.06h1.28-1.29a10 10 0 0 1 10-10v1.14l-.06-1.14h.06v1.14l-.06-1.14h.07a10 10 0 0 1 10 10h-1.22l1.22-.1v.1h-1.22l1.22-.1v.1h-1.28l-1.28.11v-.11a7.43 7.43 0 0 0-7.45-7.43v-1.29l.06 1.29h-.07a7.43 7.43 0 0 0-7.43 7.44v.06l-1.18-.05h1.18v.05l-1.18-.05h1.18a7.43 7.43 0 0 0 7.44 7.43v1.08-1.08 1.08-1.08a7.44 7.44 0 0 0 7.43-7.45h1.29l-1.28.11z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M486.72 526.08H488a10 10 0 0 1-10 10v-1.29 1.29a10 10 0 0 1-10-10V526l1.28.05H468a10 10 0 0 1 10-10v1.13l-.06-1.13h.06v1.13l-.06-1.13h.06a10 10 0 0 1 10 10h-1.23L488 526v.1h-1.23l1.23-.1v.1h-1.28l-1.28.1v-.1a7.44 7.44 0 0 0-7.45-7.44v-1.28l.06 1.28H478a7.43 7.43 0 0 0-7.43 7.44v.06h-1.18 1.18v.06h-1.18 1.18a7.45 7.45 0 0 0 7.44 7.44H478v1.07-1.07 1.07-1.07a7.44 7.44 0 0 0 7.43-7.45h1.29l-1.28.1z",
    fill: "url(#672eb7f4-1e2e-40bf-bc57-cfc041ad3e4a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256,628.42l1.92.38c.23,2.81.36,4.21.64,7,1.25-2.54,1.86-3.81,3.07-6.35l1.93.32c-.56,3.38-.83,5.07-1.38,8.45L261,638l1.24-7.38c-1.33,2.81-2,4.21-3.39,7l-1.19-.22c-.31-3.1-.45-4.65-.7-7.75-.58,2.93-.86,4.4-1.44,7.34l-1.18-.23c.67-3.32,1-5,1.67-8.36Zm8.33,5.58c.22-1.44,1-2,2.69-1.73,2.15.32,2,1.47,1.9,2.14-.19,1.42-.29,2.13-.48,3.55,0,.26-.07.51.29.56a.42.42,0,0,0,.27,0l-.09.72a3.75,3.75,0,0,1-.67,0c-.44-.06-1-.14-.92-1a2.14,2.14,0,0,1-1.88.67,1.74,1.74,0,0,1-1.74-1.74,2,2,0,0,1,.05-.42,1.7,1.7,0,0,1,1.63-1.54l1.56-.18c.85-.11.88-.31.95-.85s-.26-1-1-1.1a1.14,1.14,0,0,0-1.38.84.78.78,0,0,0,0,.22v.06Zm3.3,1.49c-.47.33-1.47.27-2,.47a1.16,1.16,0,0,0,0,2.14l.15,0a1.41,1.41,0,0,0,1.63-1c.07-.62.12-1,.21-1.6Zm7,4.43-1.09-.12.09-.79a1.62,1.62,0,0,1-1.68.77c-1.73-.2-2.21-1.64-1.95-3.65.17-1.33.67-3.31,2.66-3.07a1.75,1.75,0,0,1,1.46,1.07c.12-1.14.19-1.71.31-2.85l1.1.12Zm-2.46-1c1.26.15,1.58-.88,1.74-2.33.14-1.24,0-2.53-1.15-2.67-1-.12-1.42.82-1.61,2.34s0,2.56,1,2.68Zm5.21-1.84c-.09,1-.23,2.47,1.17,2.59,1.09.1,1.32-.9,1.36-1.38l1.13.09a2.26,2.26,0,0,1-2.43,2.09l-.2,0c-1.79-.15-2.43-1.32-2.21-3.52.16-1.6.69-3.4,2.87-3.21s2.24,1.91,2.13,3.28v.41C279.66,637.29,278.91,637.23,277.39,637.08Zm2.67-.55v-.35c.06-.72-.12-1.59-1.1-1.67-1.17-.11-1.43,1.17-1.46,1.55v.24Zm5.94-4.28,1.1.06-.05,1.15L286,633.4Zm-.12,2.13,1.12.06c-.13,2.57-.2,3.85-.33,6.42l-1.15-.06c.18-2.57.25-3.8.39-6.42Zm2.67.13h1.07v.75a2,2,0,0,1,1.76-.86c1.87.06,1.85,1.33,1.83,2.09l-.1,4.55H292c.05-1.78.07-2.67.12-4.44,0-.49,0-1.29-1-1.33a1.34,1.34,0,0,0-1.46,1.19v.06c-.07,1.77-.1,2.66-.17,4.43H288.3C288.39,638.37,288.44,637.08,288.55,634.51Zm13.89.4c-.07-.9-.46-1.66-1.6-1.65-1.61,0-1.82,1.62-1.81,3.6s.24,3.59,1.9,3.57,1.75-1.78,1.73-2.92h-1.9v-.86c1.18,0,1.78,0,3-.06.05,1.78.07,2.67.12,4.45H303v-1.16a2.14,2.14,0,0,1-2.08,1.37c-2.54,0-3-2.13-3-4.43s.44-4.44,3-4.47a2.53,2.53,0,0,1,2.84,2.48Zm3.64,3c0,1,.09,2.48,1.5,2.41,1.09,0,1.19-1.06,1.16-1.54l1.14-.06a2.28,2.28,0,0,1-2.16,2.4h-.18c-1.79.08-2.58-1-2.65-3.2-.05-1.61.24-3.47,2.43-3.56s2.46,1.59,2.54,3v.41l-3.78.14Zm2.58-.9v-.35c0-.72-.33-1.55-1.31-1.51-1.18.05-1.26,1.35-1.25,1.73v.24Zm2.26-2.67,1.12-.07.06,1a1.72,1.72,0,0,1,1.46-1.23,1.4,1.4,0,0,1,.5,0l.07,1a3,3,0,0,0-.6,0,1.51,1.51,0,0,0-1.37,1.62c.11,1.62.16,2.43.27,4l-1.15.08C311.16,638.18,311.08,636.9,310.92,634.33Zm4.08-.28,1,0,.06.75a1.92,1.92,0,0,1,1.64-1.07,1.38,1.38,0,0,1,1.63.87,2,2,0,0,1,1.58-1.19c1.86-.2,2,1.06,2.1,1.81.21,1.82.31,2.72.53,4.53l-1.15.13c-.19-1.76-.29-2.64-.49-4.41,0-.49-.18-1.28-1.1-1.18a1.25,1.25,0,0,0-1.2,1.3.49.49,0,0,0,0,.12c.17,1.77.26,2.65.44,4.42l-1.14.11c-.17-1.77-.26-2.65-.43-4.42,0-.49-.16-1.28-1.08-1.2a1.26,1.26,0,0,0-1.22,1.3s0,.07,0,.11c.14,1.77.22,2.65.37,4.42l-1.15.1Zm9.47,1c-.18-1.45.43-2.18,2.12-2.4,2.15-.29,2.31.86,2.41,1.53l.51,3.55c0,.26.08.51.43.45a.4.4,0,0,0,.26-.1l.11.72-.66.15c-.44.07-1,.14-1.15-.67a2.14,2.14,0,0,1-1.63,1.16,1.72,1.72,0,0,1-2.14-1.18,1.55,1.55,0,0,1-.07-.43,1.69,1.69,0,0,1,1.13-1.93l1.46-.6c.78-.34.75-.54.68-1.08s-.53-.88-1.27-.78a1.13,1.13,0,0,0-1.09,1.16,1,1,0,0,0,0,.25v.06Zm3.59.52c-.36.45-1.35.67-1.82,1a1,1,0,0,0-.42,1.08,1,1,0,0,0,1.17,1,1.4,1.4,0,0,0,1.29-1.41Zm2.2-3.24,1.06-.16.11.74a2,2,0,0,1,1.57-1.19c1.85-.3,2.07,1,2.2,1.7.31,1.79.47,2.69.78,4.49l-1.14.19-.74-4.37c-.08-.49-.25-1.27-1.25-1.11a1.33,1.33,0,0,0-1.21,1.44s0,0,0,.07c.27,1.75.41,2.63.69,4.38l-1.14.18c-.36-2.55-.55-3.82-.94-6.36Zm5.63-.93,1.21-.22c.93,1.93,1.4,2.89,2.36,4.8.11-2.12.17-3.19.26-5.31l1.2-.24c-.26,2.86-.41,4.28-.72,7.14-.1.92-.25,1.76-1.63,2-.45.08-.65.09-.84.11l-.14-.78a3.72,3.72,0,0,0,.67-.08A.87.87,0,0,0,339,638c0-.24.07-.36.11-.6-1.31-2.39-2-3.61-3.26-6Z"
  })), _text194 || (_text194 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.91, 0.42, -0.42, 0.91, 205.28, 608.79)"
  })), _text195 || (_text195 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(207.85 609.98) rotate(24.13)"
  })), _text196 || (_text196 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.92, 0.4, -0.4, 0.92, 210.44, 611.14)"
  })), _text197 || (_text197 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(213.02 612.25) rotate(22.56)"
  })), _text198 || (_text198 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(215.64 613.34) rotate(21.77)"
  })), _text199 || (_text199 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(218.25 614.39) rotate(20.99)"
  })), _text200 || (_text200 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(220.9 615.4) rotate(20.2)"
  })), _text201 || (_text201 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(223.56 616.38) rotate(19.41)"
  })), _text202 || (_text202 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(226.22 617.32) rotate(18.62)"
  })), _text203 || (_text203 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(228.9 618.22) rotate(17.83)"
  })), _text204 || (_text204 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(231.6 619.09) rotate(17.04)"
  })), _text205 || (_text205 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(234.31 619.92) rotate(16.25)"
  })), _text206 || (_text206 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(237.01 620.7) rotate(15.47)"
  })), _text207 || (_text207 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.97, 0.25, -0.25, 0.97, 239.74, 621.46)"
  })), _text208 || (_text208 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.97, 0.24, -0.24, 0.97, 242.48, 622.17)"
  })), _text209 || (_text209 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(245.23 622.86) rotate(13.1)"
  })), _text210 || (_text210 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.98, 0.21, -0.21, 0.98, 247.98, 623.49)"
  })), _text211 || (_text211 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.98, 0.2, -0.2, 0.98, 250.74, 624.1)"
  })), _text212 || (_text212 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(253.52 624.66) rotate(10.75)"
  })), _text213 || (_text213 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.98, 0.17, -0.17, 0.98, 256.31, 625.19)"
  })), _text214 || (_text214 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(259.07 625.68) rotate(9.18)"
  })), _text215 || (_text215 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(261.89 626.13) rotate(8.39)"
  })), _text216 || (_text216 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(264.67 626.54) rotate(7.61)"
  })), _text217 || (_text217 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.99, 0.12, -0.12, 0.99, 267.48, 626.92)"
  })), _text218 || (_text218 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(270.29 627.25) rotate(6.05)"
  })), _text219 || (_text219 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(273.07 627.55) rotate(5.28)"
  })), _text220 || (_text220 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(275.91 627.81) rotate(4.5)"
  })), _text221 || (_text221 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(278.77 628.06) rotate(3.06)"
  }, "C")), _text222 || (_text222 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(286.42 628.41) rotate(1.93)"
  }, "R")), _text223 || (_text223 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(1, -0.02, 0.02, 1, 293.64, 628.59)"
  }, "P")), _text224 || (_text224 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(300.45 628.47) rotate(-2.35)"
  }, "-")), _text225 || (_text225 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(304.59 628.32) rotate(-3.86)"
  }, "5")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5RearFrame);
export default __webpack_public_path__ + "static/media/crp5-rear-frame.2ce0a7f77c6ef236e05e2f34da0d235a.svg";
export { ForwardRef as ReactComponent };